import { CMS_PREFIX_LIST } from "./cmsPrefix";
import { mapToCopyFileShared } from "./mapToCopyFileShared";

const mapToCopyFileWebshop = (copy: Record<string, string>) => {
  const baseUrl = CMS_PREFIX_LIST.webshop;
  const getCopyValue = (key: string) => copy?.[`${baseUrl}/${key}`] ?? "";
  const getSelectTherapyPlanStep = (key: string) => copy?.[`${baseUrl}/SelectTherapyPlanStep/${key}`] ?? "";
  const getResultStep = (key: string) => copy?.[`${baseUrl}/ResultStep/${key}`] ?? "";
  const getPaymentStep = (key: string) => copy?.[`${baseUrl}/PaymentStep/${key}`] ?? "";
  const getPaymentProductCard = (key: string) => getPaymentStep(`ProductCard/${key}`);
  const getPaymentForm = (key: string) => getPaymentStep(`PersonalDetailsForm/${key}`);

  const sharedStories = mapToCopyFileShared(copy);

  const webshopCopies = {
    ...sharedStories,
    checkoutPage: {
      continueButtonText: getCopyValue("ContinueButtonText"),
      selectTherapyPlanStep: {
        title: getSelectTherapyPlanStep("Title"),
        subtitle: getSelectTherapyPlanStep("Subtitle"),
        therapyPlanSectionDescriptionDefault: getSelectTherapyPlanStep("TherapyPlanSectionDescriptionDefault"),
        therapyPlanSectionDescriptionOther: getSelectTherapyPlanStep("TherapyPlanSectionDescriptionOther"),

      },
      resultStep: {
        customTherapyPlan: {
          title: getResultStep("CustomTherapyPlan/Title"),
          subtitle: getResultStep("CustomTherapyPlan/Subtitle"),
          textAreaPlaceholder: getResultStep("CustomTherapyPlan/TextAreaPlaceholder"),
        },
        physiotherapistCard: {
          name: getResultStep("PhysiotherapistCard/Name"),
          clinic: getResultStep("PhysiotherapistCard/Clinic"),
          bio: getResultStep("PhysiotherapistCard/Bio"),
        },
        specifiedTherapyPlan: {
          title: getResultStep("SpecifiedTherapyPlan/Title"),
          subtitle: getResultStep("SpecifiedTherapyPlan/Subtitle"),
          programCard: {
            title: getResultStep("SpecifiedTherapyPlan/ProgramCard/Title"),
            connectWithPhysiotherapist: {
              title: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/0/title"),
              description: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/0/description"),
            },
            structuredRecovery: {
              title: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/1/title"),
              description: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/1/description"),
            },
            tailoredExercises: {
              title: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/2/title"),
              description: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/2/description"),
            },
            unlimitedTraining: {
              title: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/3/title"),
              description: getResultStep("SpecifiedTherapyPlan/ProgramCard/ProgramComponents/3/description"),
            },
          },
        },
      },
      paymentStep: {
        productCard: {
          productName: getPaymentProductCard("ProductName"),
          productNameCustom: getPaymentProductCard("ProductNameCustom"),
          price: getPaymentProductCard("price"),
          perMonth: getPaymentProductCard("perMonth"),
          designedFor3MonthsExplanation: getPaymentProductCard("designedFor3MonthsExplanation"),
          codeApplied: getPaymentProductCard("codeApplied"),
          cancelSectionInFaqUrl: getPaymentProductCard("cancelSectionInFaqUrl"),
          defaultCouponCode: getPaymentProductCard("DefaultCouponCode"),
          savedAmount: getPaymentProductCard("savedAmount"),
          totalTodayLabel: getPaymentProductCard("totalTodayLabel"),
          totalPrice: getPaymentProductCard("totalPrice"),
          youSaveThisMuchExplanation: getPaymentProductCard("youSaveThisMuchExplanation"),
          steps: {
            detailsTitle: getPaymentProductCard("steps/0/title"),
            detailsDescription: getPaymentProductCard("steps/0/description"),
            downloadTitle: getPaymentProductCard("steps/1/title"),
            downloadDescription: getPaymentProductCard("steps/1/description"),
            startTitle: getPaymentProductCard("steps/2/title"),
            startDescription: getPaymentProductCard("steps/2/description"),
          },
        },
        personalDetailsForm: {
          title: getPaymentForm("Title"),
          firstNameLabel: getPaymentForm("FirstNameLabel"),
          firstNameError: getPaymentForm("FirstNameError"),
          firstNamePlaceholder: getPaymentForm("FirstNamePlaceholder"),
          lastNameLabel: getPaymentForm("LastNameLabel"),
          lastNameError: getPaymentForm("LastNameError"),
          lastNamePlaceholder: getPaymentForm("LastNamePlaceholder"),
          dateOfBirthLabel: getPaymentForm("DateOfBirthLabel"),
          dateOfBirthPlaceholder: getPaymentForm("DateOfBirthPlaceholder"),
          dateOfBirthTooRecent: getPaymentForm("DateOfBirthTooRecent"),
          dateOfBirthInvalid: getPaymentForm("DateOfBirthInvalid"),
          emailLabel: getPaymentForm("EmailLabel"),
          emailPlaceholder: getPaymentForm("EmailPlaceholder"),
          emailInvalid: getPaymentForm("EmailInvalid"),
          emailAlreadyUsed: getPaymentForm("EmailAlreadyUsed"),
          termsAgreementStatement: getPaymentForm("TermsAgreementStatement"),
          termsAndConditionsLabel: getPaymentForm("TermsAndConditionsLabel"),
          privacyPolicyLabel: getPaymentForm("PrivacyPolicyLabel"),
          continueToPaymentButton: getPaymentForm("ContinueToPaymentButton"),
          paymentFailedText: getPaymentForm("PaymentFailedText"),
        },
      },
    },
  };

  return webshopCopies;
};

export { mapToCopyFileWebshop };
